import { useEffect, useState } from 'react';
import { Moon, Sun } from 'lucide-react';
import { cn } from '@/lib/utils';

const STORAGE_KEY = 'unifemga-theme';

/**
 * Light/dark toggle.
 *
 * The initial class is applied by an inline script in index.html before first
 * paint; this component only keeps React's state in step with what is already
 * on the document, so there is no flash of the wrong theme on load.
 */
export function ThemeToggle({ className }: { className?: string }) {
  const [isDark, setIsDark] = useState(
    () => typeof document !== 'undefined' && document.documentElement.classList.contains('dark'),
  );

  useEffect(() => {
    document.documentElement.classList.toggle('dark', isDark);
    localStorage.setItem(STORAGE_KEY, isDark ? 'dark' : 'light');
  }, [isDark]);

  return (
    <button
      type="button"
      onClick={() => setIsDark((value) => !value)}
      aria-label={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
      className={cn(
        'inline-flex h-10 w-10 items-center justify-center rounded-lg border border-border bg-background text-foreground-secondary transition-colors hover:bg-accent hover:text-accent-foreground',
        className,
      )}
    >
      {isDark ? <Moon size={16} /> : <Sun size={16} />}
    </button>
  );
}
